import React from 'react';

const DriverStatusBadge = ({ status }) => {
    const getStatusConfig = () => {
        switch (status) {
            case 'online':
                return {
                    label: '在線',
                    bgColor: 'bg-green-100',
                    textColor: 'text-green-600',
                    dotColor: 'bg-green-500'
                };
            case 'offline':
                return {
                    label: '離線',
                    bgColor: 'bg-gray-100',
                    textColor: 'text-gray-600',
                    dotColor: 'bg-gray-500'
                };
            case 'on_trip':
                return {
                    label: '行程中',
                    bgColor: 'bg-blue-100',
                    textColor: 'text-blue-600',
                    dotColor: 'bg-blue-500'
                };
            case 'on_break':
                return {
                    label: '休息中',
                    bgColor: 'bg-yellow-100',
                    textColor: 'text-yellow-600',
                    dotColor: 'bg-yellow-500'
                };
            default:
                return {
                    label: status,
                    bgColor: 'bg-gray-100',
                    textColor: 'text-gray-600',
                    dotColor: 'bg-gray-500'
                };
        }
    };

    const { label, bgColor, textColor, dotColor } = getStatusConfig();

    return (
        <div className="flex items-center">
            <div className={`w-2 h-2 rounded-full ${dotColor} mr-2`}></div>
            <span className={`px-2 py-1 rounded-full text-xs ${bgColor} ${textColor}`}>
                {label}
            </span>
        </div>
    );
};

export default DriverStatusBadge;